import React from "react";
import { Seo } from "../Seo";
import { VISUALLY_HIDDEN } from "../visually-hidden";
import HelpContent from "./HelpContent";

const SITE_URL = "https://achtungroyale.io";

// The /help page: the shared "how to play" body plus what a page needs to be
// found (title, description, canonical, a heading). Prerendered to static HTML
// like /about (see scripts/prerender.mjs). The h1 is visually hidden because
// the section panel already shows "How to play" as its title.
export default function HelpPage() {
  return (
    <>
      <Seo
        title="How to play Achtung, die Kurve! | Achtung Royale"
        description="The rules, controls and every power-up in Achtung Royale, the free online Achtung, die Kurve!: steer with two keys, slip through the gaps and be the last worm alive."
        canonical={`${SITE_URL}/help/`}
      />
      <h1 style={VISUALLY_HIDDEN}>How to play Achtung, die Kurve!</h1>
      <HelpContent />
    </>
  );
}
